export default class QueuesCounts {
    live: number;
    priority: number | null;

    constructor(live: number, priority: number | null) {
        this.live = live;
        this.priority = priority;
    }

    get total() {
        return this.live + (this.priority || 0);
    }
}